// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"85282074","513":"7e263899","703":"f17dae7c"}[chunkId] + ".chunk.js";
};